<template>
    <div ref="templateDiv">
        <md-card id="cardDetail" ref="cardDetail" class="cardSettings" :style="cardStyles.cardDetail">
            <md-card-content>
                <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-100">
                        <md-field>
                            <label for="seasonName">Name</label>
                            <md-input name="seasonName" id="seasonName" v-model.trim="seasonInfoTemp.n"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-100">
                        <md-field>
                            <label for="seasonRebuysAllowed">Rebuys Allowed</label>
                            <md-select v-model.number="seasonInfoTemp.r" name="seasonRebuysAllowed" id="seasonRebuysAllowed">
                                <md-option :value="rebuysAllowed.untilFirstBreakEnd">Up Until End of First Break</md-option>
                                <md-option :value="rebuysAllowed.untilSecondBreakEnd">Up Until End of Second Break</md-option>
                                <md-option :value="rebuysAllowed.always">Always</md-option>
                                <md-option :value="rebuysAllowed.never">Never</md-option>
                            </md-select>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-100">
                        <md-field>
                            <label for="seasonTopupsAllowed">Topups Allowed</label>
                            <md-select v-model.number="seasonInfoTemp.t" name="seasonTopupsAllowed" id="seasonTopupsAllowed">
                                <md-option :value="topupsAllowed.duringFirstBreak">Only During First Break</md-option>
                                <md-option :value="topupsAllowed.duringFirstAndSecondBreak">Only During First and Second Breaks</md-option>
                                <md-option :value="topupsAllowed.untilFirstBreakEnd">Up Until End of First Break</md-option>
                                <md-option :value="topupsAllowed.untilSecondBreakEnd">Up Until End of Second Break</md-option>
                                <md-option :value="topupsAllowed.always">Always</md-option>
                                <md-option :value="topupsAllowed.never">Never</md-option>
                            </md-select>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-100">
                        <md-field>
                            <label>Max Games Included in Total Points</label>
                            <md-input name="seasonMaxGames" id="seasonMaxGames" v-model.number="seasonInfoTemp.m" type="number"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-100">
                        <span>Places paid</span>
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item md-size-50">
                                <md-field>
                                    <label>For Games</label>
                                    <md-input name="seasonPaidPlacesGames" id="seasonPaidPlacesGames" v-model.number="seasonInfoTemp.gpo" type="number" min="1" max="3"></md-input>
                                </md-field>
                            </div>
                            <div class="md-layout-item md-size-50">
                                <md-field>
                                    <label>For Season</label>
                                    <md-input name="seasonPaidPlacesSeason" id="seasonPaidPlacesSeason" v-model.number="seasonInfoTemp.spo" type="number" min="1" max="3"></md-input>
                                </md-field>
                            </div>
                        </div>
                    </div>
                </div>
            </md-card-content>
            <md-card-actions>
                <md-button class="md-accent" v-if="!(activeSeasonId < 0)" @click="downloadBackup()">Backup</md-button>
                <!--<md-button class="md-accent" v-if="!(activeSeasonId < 0)" @click="uploadBackup()">Restore</md-button>-->
                <md-button class="md-accent" @click="showDeleteSeasonConfirm = true">Delete</md-button>
                <md-button class="md-accent" @click="updateSeasonInfo()">Save</md-button>
            </md-card-actions>
        </md-card>
        <md-card id="cardSharing" ref="cardSharing" class="cardSettings" :style="cardStyles.cardSharing" :class="{cardHidden: activeSeasonId < 0}">
          <md-card-header>
            <div class="md-title">Manage Sharing</div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-100">Currently shared to:</div>
              <div class="md-layout-item md-size-100 chipContainer">
                <div class="md-size-100 chipDiv" v-for="reader in sortedReaders" :key="reader.id">
                    <md-chip md-deletable @md-delete="removeReader(reader.id, reader.name)">{{reader.name}}</md-chip>
                </div>
              </div>
              <div class="md-layout-item md-size-100 dividerDiv">
                <md-divider class="sharedDivider"></md-divider>
              </div>
              <div class="md-layout-item md-size-80 addDiv">
                <md-field>
                  <label>Search for user:</label>
                  <md-input v-model="userAddShared"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-20 addButton md-field">
                <md-button class="md-icon-button md-accent" @click='searchForUser()'>
                  <md-icon>search</md-icon>
                </md-button>
              </div>
            </div>
          </md-card-content>
        </md-card>
        <md-dialog-confirm :md-active.sync="showDeleteSeasonConfirm" md-title="Delete Season?"
            :md-content="'All associated players, games, schedules, and stats will also be deleted.  This can not be undone.<br>Are you sure you want to delete season ' + seasonInfoTemp.n + '?'"
            md-confirm-text="Yes" md-cancel-text="No" @md-confirm="deleteSeason()"
        />
        <md-dialog :md-active.sync="showImportSeasonDialog" id="showImportSeasonDialog" :md-close-on-esc="false" :md-click-outside-to-close="false">
            <md-dialog-title>Season Import</md-dialog-title>
            <md-dialog-content>
                <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-100">
                        <!-- md-radio v-model="importType" value="0">Import from existing season</md-radio -->
                        <!-- md-radio v-model="importType" value="1">Import from file</md-radio -->
                        <md-radio v-model="importType" value="2">Import from previous version</md-radio>
                    </div>
                    <div class="md-layout-item md-size-45" :class="{'importPreviousVersionHidden': importType !== '2'}">
                        <md-field>
                            <label for="selectSeason">Select Season:</label>
                            <md-select v-model="importPreviousVersionSeasonId" name="selectPreviousVerisonSeason" id="selectPreviousVersionSeason">
                                <md-option v-for="season in previousVersionSeasons" :key="season.id" :value="season.id">{{season.n}}</md-option>
                            </md-select>
                        </md-field>
                    </div>
                    <div clss="md-layout-item md-size-10" :class="{'importPreviousVersionHidden': importType !== '2'}">
                        <md-button class="md-icon-button md-accent" v-if="!(importPreviousVersionSeasonId < 0)" @click="importPreviousVersionSeason">
                            <md-icon>add_circle</md-icon>
                        </md-button>
                    </div>
                </div>
            </md-dialog-content>
            <md-dialog-actions>
              <md-button class="md-accent" @click="cancelImport()">Cancel</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-active.sync="showUserSearchDialog" id="showUserSearchDialog">
            <md-dialog-title>Share Season With</md-dialog-title>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-100 chipContainer">
                <div class="md-size-100 chipDiv" v-for="(userName, userId) in returnedUsers" :key="userId">
                    <md-chip md-clickable @click="addShared(userId, userName)">{{userName}}</md-chip>
                </div>
              </div>
            </div>
        </md-dialog>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { rebuysAllowed, topupsAllowed, calculateCardPosition, caseFoldNormalize } from '../constants'

const defaultSeason = {
  n: 'New Season',
  r: rebuysAllowed.untilFirstBreakEnd,
  t: topupsAllowed.duringFirstBreak,
  m: 8,
  gpo: 3,
  spo: 3
}

export default {
  name: 'SeasonSettings',
  data: function () {
    return {
      showDeleteSeasonConfirm: false,
      showImportSeasonDialog: false,
      showUserSearchDialog: false,
      seasonInfoTemp: null,
      rebuysAllowed: rebuysAllowed,
      topupsAllowed: topupsAllowed,
      importType: 2,
      importPreviousVersionSeasonId: -1,
      previousVersionSeasons: null,
      userAddShared: '',
      windowWidth: 0,
      returnedUsers: {},
      cardPositions: {
        bigScreenColumns: 2,
        smallScreenColumns: 1,
        screenTransitionWidth: 500,
        columnsLinedUp: true,
        rowPadding: 16,
        columnPadding: 16,
        cards: [
          {
            id: 'cardDetail',
            bigScreenColumn: 1,
            bigScreenRow: 1,
            smallScreenColumn: 1,
            smallScreenRow: 1,
            width: 475,
            height: 465
          },
          {
            id: 'cardSharing',
            bigScreenColumn: 2,
            bigScreenRow: 1,
            smallScreenColumn: 1,
            smallScreenRow: 2,
            width: 475,
            height: 465
          }
        ]
      },
      cardStyles: {
        cardDetail: {
          top: '0px',
          left: '0px',
          transform: 'scale(1)'
        },
        cardSharing: {
          top: '0px',
          left: '0px',
          transform: 'scale(1)'
        }
      }
    }
  },
  created: function () {
    if (this.activeSeasonId < 0) {
      switch (this.activeSeasonId) {
        case -2:
          // new
          this.seasonInfoTemp = JSON.parse(JSON.stringify(defaultSeason))
          break
        case -3:
          // Imported
          this.seasonInfoTemp = {}
          this.showImportSeasonDialog = true
          this.$store.dispatch('getPreviousVersionSeasonList').then(seasons => {
            this.previousVersionSeasons = seasons
          })
          break
        default:
          // empty or unexpected
          this.seasonInfoTemp = {}
          break
      }
      this.seasonInfoTemp.id = this.activeSeasonId
    } else {
      this.seasonInfoTemp = JSON.parse(JSON.stringify(this.currentSeason))
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.storeWindowWidth)
      this.storeWindowWidth()
    })
  },
  computed: {
    ...mapGetters(['currentSeason', 'getUser']),
    ...mapState(['activeSeasonId', 'shared']),
    windowScale: function () {
      let scale = 1
      if (this.windowWidth >= 500) {
        scale = (this.windowWidth - 64) / 1000
      } else {
        scale = (this.windowWidth - 32) / 500
      }
      return scale
    },
    sortedReaders: function () {
      let sortable = []
      if (this.activeSeasonId < 0) {
        return sortable
      }
      for (let reader in this.currentSeason.readers) {
        sortable.push({id: reader, name: this.currentSeason.readers[reader]})
      }

      sortable.sort(function (a, b) {
        var nameA = caseFoldNormalize(a.name)
        var nameB = caseFoldNormalize(b.name)

        if (nameA < nameB) {
          return -1
        }

        if (nameA > nameB) {
          return 1
        }

        return 0
      })
      return sortable
    }
  },
  methods: {
    ...mapActions(['displayError', 'displayMessage']),
    updateSeasonInfo: function () {
      this.$store.dispatch('seasonUpdate', this.seasonInfoTemp).then(
      )
    },
    addSeason: function () {
      this.seasonInfoTemp = {id: -1, n: ''}
    },
    deleteSeason: function () {
      let seasonName = this.seasonInfoTemp.n
      this.$store.dispatch('seasonDelete', this.seasonInfoTemp.id).then(() => {
        this.displayMessage('Season ' + seasonName + ' deleted successfully.')
        this.$router.push('/home')
      }).catch((err) => {
        this.displayError('Season delete failed. ' + err.message)
      })
    },
    downloadBackup: function () {
      this.$store.dispatch('backupSeason', this.seasonInfoTemp.id).then(function (seasonJSON) {
        let blob = new Blob([JSON.stringify(seasonJSON)], { type: 'text/json' })
        const tempEvent = document.createEvent('MouseEvents')
        let tempLink = document.createElement('a')
        tempLink.download = seasonJSON.n + '.json'
        tempLink.href = window.URL.createObjectURL(blob)
        tempLink.dataset.downloadurl = ['text/json', tempLink.download, tempLink.href].join(':')
        tempEvent.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
        tempLink.dispatchEvent(tempEvent)
      })
    },
    importPreviousVersionSeason: function () {
      this.$store.dispatch('importSeasonPreviousVersion', this.importPreviousVersionSeasonId).then(() => {
        this.showImportSeasonDialog = false
      }).catch((err) => {
        this.displayError('Import of Previous Version Season failed. ' + err.message)
      })
    },
    cancelImport: function () {
      this.$store.dispatch('clearActiveSeason')
      this.$router.push('/home')
    },
    removeReader: function (readerId, reader) {
      this.$store.dispatch('deleteSeasonReader', { readerId: readerId, seasonId: this.activeSeasonId }).then(wasDeleted => {
        if (!wasDeleted) {
          this.displayError(reader + ' was no longer shared to.')
        }
      }).catch((err) => {
        this.displayError('Removal of shared user failed. ' + err.message)
      })
    },
    storeWindowWidth: function () {
      this.windowWidth = window.innerWidth
      let scale = this.windowScale
      let cards = calculateCardPosition(this.cardPositions, this.windowWidth, scale)
      let templateTop = this.$refs.templateDiv.getBoundingClientRect().top
      let templateLeft = this.$refs.templateDiv.getBoundingClientRect().left
      for (let columns = 0; columns < cards.length; columns++) {
        const column = cards[columns]
        for (let rows = 0; rows < column.length; rows++) {
          const card = column[rows]
          this.cardStyles[card.id].top = (templateTop + card.top) + 'px'
          this.cardStyles[card.id].left = (templateLeft + card.left) + 'px'
          this.cardStyles[card.id].transform = 'scale(' + scale + ')'
        }
      }
    },
    searchForUser: function () {
      let searchUser = this.userAddShared
      if (searchUser !== '') {
        if (searchUser.length >= 3) {
          this.$store.dispatch('searchByUsername', searchUser).then(usersObject => {
            for (let i = 0; i < Object.keys(usersObject).length; i++) {
              const userId = Object.keys(usersObject)[i]
              if (userId === this.getUser.uid || Object.keys(this.currentSeason.readers).includes(userId)) {
                delete usersObject[userId]
              }
            }
            if (Object.keys(usersObject).length > 0) {
              this.returnedUsers = usersObject
              this.showUserSearchDialog = true
            } else {
              this.displayError('No users found matching ' + searchUser)
            }
          }).catch((err) => {
            this.displayError('Search for user ' + searchUser + ' failed: ' + err.message)
          })
        } else {
          this.displayError('Search needs to be three or more characters.')
        }
      } else {
        this.displayError('Search needs to be three or more characters.')
      }
    },
    addShared: function (userId, userName) {
      this.$store.dispatch('addSeasonReader', { readerId: userId, seasonId: this.activeSeasonId }).then(() => {
        this.userAddShared = ''
        this.showUserSearchDialog = false
        for (var property in this.returnedUsers) delete this.returnedUsers[property]
      }).catch((err) => {
        this.showUserSearchDialog = false
        for (var property in this.returnedUsers) delete this.returnedUsers[property]
        this.displayError('Sharing to user ' + userName + ' failed: ' + err.message)
      })
    }
  },
  watch: {
    activeSeasonId: function (seasonId) {
      if (seasonId < 0) {
        switch (seasonId) {
          case '-2':
          // new
            this.seasonInfoTemp = JSON.parse(JSON.stringify(defaultSeason))
            this.seasonInfoTemp.id = seasonId
            break
          case '-3':
          // import
            this.seasonInfoTemp = {}
            this.showImportSeasonDialog = true
            this.$store.dispatch('getPreviousVersionSeasonList').then(seasons => {
              this.previousVersionSeasons = seasons
            })
            break
          default:
          // empty or unexpected
            this.seasonInfoTemp = {}
            this.seasonInfoTemp.id = seasonId
        }
      } else {
        this.seasonInfoTemp = JSON.parse(JSON.stringify(this.currentSeason))
      }
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.storeWindowWidth)
  }
}
</script>

<style lang="scss">
  .highlighted {
      background-color: #454849;
  }
  .cardSettings {
    position: absolute;
    height: 465px;
    width: 475px;
    transform-origin: left top;
  }
  .md-card-content {
      padding: 5px;
  }
  .md-card-content {
      padding: 5px;
  }
  #cardSeason i {
      color: #ff9800 !important;
  }
  .md-button {
      margin: 6px 4px;
  }
  .md-icon-button {
      margin: 0 6px;
  }
  .importPreviousVersionHidden {
    display: none;
  }
  #cardShared i {
    color: #ff9800 !important;
  }
  #cardShared svg {
    fill: #ff9800 !important;
  }
  .chipContainer {
    height: 285px;
    overflow-y: auto;
  }
  .chipDiv {
    padding-bottom: 2px;
  }
  .dividerDiv {
    padding-bottom: 0px;
    padding-top: 10px;
  }
  .addDiv {
    height: 40px;
  }
  .addButton {
    height: 40px;
    text-align: left;
    margin: 0px;
  }
  .cardHidden {
    display: none;
  }
</style>
